export const LABELS = {
  TITLE: 'Information requested',
  SUBTITLE: 'The property manager reviewing your application has requested some more information',
  BUTTON: 'Resolve',
};
